import { EvidenceSectionName, EvidenceSectionNameMap } from 'api/brokerCases/types';
import { ExclamationIcon } from 'components/common/Icons';
import { EVIDENCE_SECTION_CONFIG } from 'pages/EvidencePage/evidenceConfig';

export interface IEvidenceTypeIconProps {
  name: EvidenceSectionName;
}

export const EvidenceTypeIcon = ({ name }: IEvidenceTypeIconProps) => {
  const { icon: IconComponent } = EVIDENCE_SECTION_CONFIG[name];
  const isOther = name === EvidenceSectionNameMap.OTHER_DOCUMENTS;
  const isFurtherInformationRequired = name === EvidenceSectionNameMap.FURTHER_INFORMATION_REQUIRED;

  return (
    <div
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl p-2 ${
        isOther ? 'bg-gray-100' : isFurtherInformationRequired ? 'bg-[#FFEDD4]' : 'bg-green-200'
      }`}
    >
      {isFurtherInformationRequired ? (
        <ExclamationIcon color='#B45309' />
      ) : (
        <IconComponent className='h-6 w-6 text-black' />
      )}
    </div>
  );
};
